<template>
  <v-container fluid grid-list-xl>
    <v-card>
      <v-toolbar
        dark
        color="secondary"
      >
        <v-toolbar-side-icon><v-icon>event</v-icon></v-toolbar-side-icon>
        <v-toolbar-title>{{$tc('app.schedule', 1)}}</v-toolbar-title>
      </v-toolbar>
      <calendar-view
        @show-date-change="setShowDate"
        :show-date="showDate"
        :starting-day-of-week="startingDayOfWeek"
        :display-period-uom="displayPeriodUom"
        :events="scheduleEvents"
        @click-event="openEditEventModal(...arguments)"
      >
      </calendar-view>
    </v-card>

    <v-btn
      v-if="$store.getters.hasPermission('edit_organization_schedule')"
      id="create-event-button"
      @click="createEventModalVisible = true"
      fixed
      dark
      fab
      bottom
      right
      color="accent"
      style="z-index: 100;"
    >
      <v-icon>add</v-icon>
    </v-btn>

    <v-dialog
      v-if="$store.getters.hasPermission('edit_organization_schedule')"
      v-model="createEventModalVisible"
      max-width="500px"
    >
      <v-card>
        <v-card-title primary-title>
          <h3 class="headline">{{ $t("schedule.createNewEvent") }}</h3>
        </v-card-title>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12>
              <v-select
                v-model="newEventPlaylistID"
                :items="playlists"
                item-text="name"
                item-value="id"
                label="Playlist"
                outline
                required
              ></v-select>
            </v-flex>

            <v-flex xs12>
              <h3><b>{{$tc('schedule.color', 1)}}</b></h3>
            </v-flex>

            <v-flex xs12 mb-2>
              <v-btn
                v-for="(color, index) in colors"
                :color="color.value"
                :key="index"
                :outline="!color.selected"
                @click="setNewEventColor(index)"
                small
                dark
                fab
              >
                <v-icon>event</v-icon>
              </v-btn>
            </v-flex>

            <v-flex xs12>
              <v-text-field
                v-model="newEventName"
                name="new-event-name"
                type="text"
                :label="$t('schedule.title')"
                prepend-icon="title"
                required
                autofocus
              ></v-text-field>
            </v-flex>

            <v-flex xs6>
              <v-menu
                v-model="newEventStartDatePickerVisible"
                ref="newEventStartDatePicker"
                transition="scale-transition"
                min-width="290px"
                :nudge-right="40"
                :close-on-content-click="false"
                :return-value.sync="newEventStartDate"
                lazy
                offset-y
                full-width
              >
                <v-text-field
                  slot="activator"
                  v-model="newEventStartDate"
                  prepend-icon="event"
                  :label="$t('schedule.startDate')"
                  readonly
                  required
                ></v-text-field>
                <v-date-picker
                  v-model="newEventStartDate"
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    color="accent"
                    @click="newEventStartDatePickerVisible = false"
                    flat
                  >Cancel</v-btn>
                  <v-btn
                    color="accent"
                    @click="$refs.newEventStartDatePicker.save(newEventStartDate)"
                    flat
                  >OK</v-btn>
                </v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs6>
              <v-menu
                v-model="newEventEndDatePickerVisible"
                ref="newEventEndDatePicker"
                transition="scale-transition"
                min-width="290px"
                :nudge-right="40"
                :close-on-content-click="false"
                :return-value.sync="newEventEndDate"
                lazy
                offset-y
                full-width
              >
                <v-text-field
                  slot="activator"
                  v-model="newEventEndDate"
                  prepend-icon="event"
                  :label="$t('schedule.endDate')"
                  readonly
                  required
                ></v-text-field>
                <v-date-picker
                  v-model="newEventEndDate"
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    color="accent"
                    @click="newEventEndDatePickerVisible = false"
                    flat
                  >Cancel</v-btn>
                  <v-btn
                    color="accent"
                    @click="$refs.newEventEndDatePicker.save(newEventEndDate)"
                    flat
                  >OK</v-btn>
                </v-date-picker>
              </v-menu>
            </v-flex>

            <v-flex
              xs6
            >
              <v-combobox
                v-mask="'##:##'"
                v-model="newEventStartTime"
                prepend-icon="timer"
                :items="times"
                :label="$t('schedule.startTime')"
                required
              ></v-combobox>
            </v-flex>

            <v-flex
              xs6
            >
              <v-combobox
                v-mask="'##:##'"
                v-model="newEventEndTime"
                prepend-icon="timer_off"
                :items="times"
                :label="$t('schedule.endTime')"
                required
              ></v-combobox>
            </v-flex>

            <v-flex xs12>
              <v-select
                :items="intervals"
                v-model="newEventRepeatInterval"
                label="Repeat"
              ></v-select>
            </v-flex>

            <!-- <v-flex
              v-if="newEventRepeatInterval"
              xs12
            >
              <v-combobox
                v-mask="'##:##'"
                v-model="newEventRepeatTime"
                prepend-icon="timer"
                :items="times"
                label="Time"
                required
              ></v-combobox>
            </v-flex>

            <v-flex
              v-if="newEventRepeatInterval === 'weekly' || newEventRepeatInterval === 'monthly'"
              text-xs-center
              xs12
            >
              <v-select
                v-model="newEventRepeatDay"
                :items="days"
                label="Day"
                item-text="text"
                item-value="value"
                attach
                chips
              ></v-select>
            </v-flex>

            <v-flex
              v-if="newEventRepeatInterval === 'monthly'"
              text-xs-center
              xs12
            >
              <v-select
                v-model="newEventRepeatMonth"
                :items="months"
                label="Month"
                item-text="text"
                item-value="value"
                attach
                chips
              ></v-select>
            </v-flex> -->
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="closeCreateEventModal()">Close</v-btn>
          <v-btn dark color="accent" @click="createScheduleEvent()">Create</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-if="$store.getters.hasPermission('edit_organization_schedule') && currentEvent"
      v-model="editEventModalVisible"
      max-width="500px"
    >
      <v-card>
        <v-card-title primary-title>
          <h3 class="headline">{{ $t("schedule.editEvent") }}</h3>
        </v-card-title>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12>
              <v-select
                v-model="currentEvent.playlist_id"
                :items="playlists"
                item-text="name"
                item-value="id"
                label="Playlist"
                outline
                required
              ></v-select>
            </v-flex>

            <v-flex xs12>
              <h3><b>{{$tc('schedule.color', 1)}}</b></h3>
            </v-flex>

            <v-flex xs12 mb-2>
              <v-btn
                v-for="(color, index) in colors"
                :color="color.value"
                :key="index"
                :outline="!color.selected"
                @click="setCurrentEventColor(index)"
                small
                dark
                fab
              >
                <v-icon>event</v-icon>
              </v-btn>
            </v-flex>

            <v-flex xs12>
              <v-text-field
                v-model="currentEvent.title"
                name="current-event-name"
                type="text"
                :label="$t('schedule.title')"
                prepend-icon="title"
                required
                autofocus
              ></v-text-field>
            </v-flex>

            <v-flex xs6>
              <v-menu
                v-model="currentEventStartDatePickerVisible"
                ref="currentEventStartDatePicker"
                transition="scale-transition"
                min-width="290px"
                :nudge-right="40"
                :close-on-content-click="false"
                :return-value.sync="currentEvent.startDate"
                lazy
                offset-y
                full-width
              >
                <v-text-field
                  slot="activator"
                  v-model="currentEvent.startDate"
                  prepend-icon="event"
                  :label="$t('schedule.startDate')"
                  readonly
                  required
                ></v-text-field>
                <v-date-picker
                  v-model="currentEvent.startDate"
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    color="accent"
                    @click="currentEventStartDatePickerVisible = false"
                    flat
                  >Cancel</v-btn>
                  <v-btn
                    color="accent"
                    @click="$refs.currentEventStartDatePicker.save(currentEvent.startDate)"
                    flat
                  >OK</v-btn>
                </v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs6>
              <v-menu
                v-model="currentEventEndDatePickerVisible"
                ref="currentEventEndDatePicker"
                transition="scale-transition"
                min-width="290px"
                :nudge-right="40"
                :close-on-content-click="false"
                :return-value.sync="currentEvent.endDate"
                lazy
                offset-y
                full-width
              >
                <v-text-field
                  slot="activator"
                  v-model="currentEvent.endDate"
                  prepend-icon="event"
                  :label="$t('schedule.endDate')"
                  readonly
                  required
                ></v-text-field>
                <v-date-picker
                  v-model="currentEvent.endDate"
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    color="accent"
                    @click="currentEventEndDatePickerVisible = false"
                    flat
                  >Cancel</v-btn>
                  <v-btn
                    color="accent"
                    @click="$refs.currentEventEndDatePicker.save(currentEvent.endDate)"
                    flat
                  >OK</v-btn>
                </v-date-picker>
              </v-menu>
            </v-flex>

            <v-flex
              xs6
            >
              <v-combobox
                v-mask="'##:##'"
                v-model="currentEvent.start_time"
                prepend-icon="timer"
                :items="times"
                label="Start time"
                required
              ></v-combobox>
            </v-flex>

            <v-flex
              xs6
            >
              <v-combobox
                v-mask="'##:##'"
                v-model="currentEvent.end_time"
                prepend-icon="timer_off"
                :items="times"
                label="End time"
                required
              ></v-combobox>
            </v-flex>

            <v-flex xs12>
              <v-select
                :items="intervals"
                v-model="currentEvent.repeat_interval"
                label="Repeat"
              ></v-select>
            </v-flex>

            <!-- <v-flex
              v-if="currentEvent.repeat_interval"
              xs12
            >
              <v-combobox
                v-mask="'##:##'"
                v-model="currentEvent.repeat_time"
                prepend-icon="timer"
                :items="times"
                label="Time"
                required
              ></v-combobox>
            </v-flex> -->

            <!-- <v-flex
              v-if="
                currentEvent.repeat_interval === 'weekly' ||
                currentEvent.repeat_interval === 'monthly'
              "
              text-xs-center
              xs12
            >
              <v-select
                v-model="currentEvent.repeat_day"
                :items="days"
                label="Day"
                item-text="text"
                item-value="value"
                attach
                chips
              ></v-select>
            </v-flex> -->

            <!-- <v-flex
              v-if="currentEvent.repeat_interval === 'monthly'"
              text-xs-center
              xs12
            >
              <v-select
                v-model="currentEvent.repeat_month"
                :items="months"
                label="Month"
                item-text="text"
                item-value="value"
                attach
                chips
              ></v-select>
            </v-flex> -->
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="closeEditEventModal()">Close</v-btn>
          <v-btn outline color="accent" @click="deleteScheduleEvent()">Delete</v-btn>
          <v-btn dark color="accent" @click="editScheduleEvent()">Edit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import VeeValidate from 'vee-validate';
import VueMoment from 'vue-moment';
import { mask } from 'vue-the-mask';
import CalendarView from './CalendarView.vue';
import CalendarMathMixin from './CalendarMathMixin';

Vue.use(VeeValidate, { fieldsBagName: 'veeErrors' });
Vue.use(VueMoment);

export default {
  directives: { mask },
  components: {
    CalendarView,
    /* eslint-disable vue/no-unused-components */
    CalendarMathMixin,
    /* esling-enable */
  },
  data() {
    return {
      startingDayOfWeek: 1,
      showDate: new Date(),
      displayPeriodUom: 'month',
      apiUrl: window.api_url,
      playlists: [],
      scheduleEvents: [],
      createEventModalVisible: false,
      editEventModalVisible: false,

      currentEvent: null,
      currentEventStartDatePickerVisible: false,
      currentEventEndDatePickerVisible: false,

      newEventName: '',
      newEventPlaylistID: null,
      newEventStartDate: null,
      newEventStartDatePickerVisible: false,
      newEventEndDate: null,
      newEventEndDatePickerVisible: false,
      newEventStartTime: null,
      newEventEndTime: null,
      newEventRepeatInterval: null,
      newEventRepeatTime: null,
      newEventRepeatDay: null,
      newEventRepeatMonth: null,
      newEventColor: null,

      times: [
        '00:00', '00:30',
        '01:00', '01:30',
        '02:00', '02:30',
        '03:00', '03:30',
        '04:00', '04:30',
        '05:00', '05:30',
        '06:00', '06:30',
        '07:00', '07:30',
        '08:00', '08:30',
        '09:00', '09:30',
        '10:00', '10:30',
        '11:00', '11:30',
        '12:00', '12:30',
        '13:00', '13:30',
        '14:00', '14:30',
        '15:00', '15:30',
        '16:00', '16:30',
        '17:00', '17:30',
        '18:00', '18:30',
        '19:00', '19:30',
        '20:00', '20:30',
        '21:00', '21:30',
        '22:00', '22:30',
        '23:00', '23:30',
      ],
      intervals: [
        { text: this.$i18n.t('general.disabled'), value: null },
        { text: this.$i18n.t('schedule.daily'), value: 'daily' },
        { text: this.$i18n.t('schedule.weekly'), value: 'weekly' },
        // { text: this.$i18n.t('schedule.monthly'), value: 'monthly' },
      ],
      days: [
        { text: this.$i18n.t('schedule.monday'), value: 1 },
        { text: this.$i18n.t('schedule.tuesday'), value: 2 },
        { text: this.$i18n.t('schedule.wednesday'), value: 3 },
        { text: this.$i18n.t('schedule.thursday'), value: 4 },
        { text: this.$i18n.t('schedule.friday'), value: 5 },
        { text: this.$i18n.t('schedule.saturday'), value: 6 },
        { text: this.$i18n.t('schedule.sunday'), value: 0 },
      ],
      months: [
        { text: this.$i18n.t('schedule.january'), value: 0 },
        { text: this.$i18n.t('schedule.february'), value: 1 },
        { text: this.$i18n.t('schedule.march'), value: 2 },
        { text: this.$i18n.t('schedule.april'), value: 3 },
        { text: this.$i18n.t('schedule.may'), value: 4 },
        { text: this.$i18n.t('schedule.june'), value: 5 },
        { text: this.$i18n.t('schedule.july'), value: 6 },
        { text: this.$i18n.t('schedule.august'), value: 7 },
        { text: this.$i18n.t('schedule.september'), value: 8 },
        { text: this.$i18n.t('schedule.october'), value: 9 },
        { text: this.$i18n.t('schedule.novermber'), value: 10 },
        { text: this.$i18n.t('schedule.december'), value: 11 },
      ],
      colors: [
        { value: 'red', selected: false },
        { value: 'pink', selected: false },
        { value: 'purple', selected: false },
        { value: 'deep-purple', selected: false },
        { value: 'indigo', selected: false },
        { value: 'blue', selected: false },
        { value: 'light-blue', selected: false },
        { value: 'cyan', selected: false },
        { value: 'teal', selected: false },
        { value: 'green', selected: false },
        { value: 'light-green', selected: false },
        { value: 'lime', selected: false },
        { value: 'yellow', selected: false },
        { value: 'amber', selected: false },
        { value: 'orange', selected: false },
        { value: 'deep-orange', selected: false },
        { value: 'brown', selected: false },
        { value: 'blue-grey', selected: false },
        { value: 'grey', selected: false },
        { value: 'black', selected: false },
      ],
    };
  },
  mounted() {
    this.getPlaylists();
    this.getScheduleEvents();
  },
  methods: {
    getPlaylists() {
      const vm = this;

      axios.get(`${this.apiUrl}api/playlists`)
        .then((response) => {
          vm.playlists = response.data.data;
        })
        .catch((error) => {
          vm.$toasted.show(error.response.data.message, { duration: 3000, singleton: true, type: 'error' });
        });
    },
    getScheduleEvents() {
      const vm = this;

      axios.get(`${this.apiUrl}api/schedule/events`)
        .then((response) => {
          vm.scheduleEvents = response.data.data;
          this.generateRepeatEvents();
        })
        .catch((error) => {
          vm.$toasted.show(error.response.data.message, { duration: 3000, singleton: true, type: 'error' });
        });
    },
    generateRepeatEvents() {
      this.scheduleEvents.forEach((event) => {
        if (event.repeat_interval === 'daily' && !event.isGeneratedRepeatEvent) {
          for (let day = 1; day <= this.$moment().daysInMonth(); day += 1) {
            if (day !== parseInt(this.$moment(event.startDate).format('DD'), 10)) {
              const startDay = this.$moment(event.startDate).day();
              const endDay = this.$moment(event.endDate).day();
              const dayDiff = endDay - startDay;

              const newEvent = {
                title: event.title,
                originalEventID: event.id,
                isGeneratedRepeatEvent: true,
                repeat_interval: event.repeat_interval,
                classes: event.classes,
                startDate: this.$moment().date(day).format('YYYY-MM-DD'),
                endDate: this.$moment().date(day + dayDiff).format('YYYY-MM-DD'),
              };

              this.scheduleEvents.push(newEvent);
            }
          }
        } else if (event.repeat_interval === 'weekly' && !event.isGeneratedRepeatEvent) {
          const monthFirstWeek = this.$moment().startOf('month').week();
          let monthLastWeek = this.$moment().endOf('month').week();

          if (monthFirstWeek > monthLastWeek) {
            monthLastWeek = monthFirstWeek + monthLastWeek;
          }

          for (let week = monthFirstWeek; week <= monthLastWeek; week += 1) {
            if (
              parseInt(this.$moment(event.startDate).format('DD'), 10)
              !== parseInt(this.$moment().week(week).day(event.repeat_day).format('DD'), 10)
            ) {
              const startDay = this.$moment(event.startDate).day();
              const endDay = this.$moment(event.endDate).day();
              const newEvent = {
                title: event.title,
                originalEventID: event.id,
                isGeneratedRepeatEvent: true,
                repeat_interval: event.repeat_interval,
                classes: event.classes,
                startDate: this.$moment().day(startDay).week(week).format('YYYY-MM-DD'),
                endDate: this.$moment().day(endDay).week(week).format('YYYY-MM-DD'),
              };

              this.scheduleEvents.push(newEvent);
            }
          }
        }
      });
    },
    createScheduleEvent() {
      const vm = this;
      const newScheduleEvent = {
        title: this.newEventName,
        playlist_id: this.newEventPlaylistID,
        startDate: this.newEventStartDate,
        endDate: this.newEventEndDate,
        start_time: this.newEventStartTime,
        end_time: this.newEventEndTime,
        repeat_interval: this.newEventRepeatInterval,
        repeat_time: this.newEventRepeatTime,
        repeat_day: this.newEventRepeatDay,
        repeat_month: this.newEventRepeatMonth,
        classes: this.newEventColor,
      };

      if (this.newEventRepeatInterval === 'daily') {
        newScheduleEvent.repeat_time = newScheduleEvent.start_time;
      } else if (this.newEventRepeatInterval === 'weekly') {
        newScheduleEvent.repeat_time = newScheduleEvent.start_time;
        newScheduleEvent.repeat_day = this.$moment(newScheduleEvent.startDate).day();
      }

      this.closeCreateEventModal();

      axios.post(`${this.apiUrl}api/schedule/event`, newScheduleEvent)
        .then((response) => {
          vm.$toasted.show(response.data.message, { duration: 3000, singleton: true, type: 'success' });
          this.scheduleEvents.push(response.data.data);
          this.scheduleEvents = this.scheduleEvents.filter(
            item => !item.isGeneratedRepeatEvent,
          );
          this.generateRepeatEvents();
        })
        .catch((error) => {
          vm.$toasted.show(error.response.data.message, { duration: 3000, singleton: true, type: 'error' });
        });
    },
    editScheduleEvent() {
      const vm = this;

      this.closeEditEventModal();

      axios.patch(`${this.apiUrl}api/schedule/event/${this.currentEvent.id}`, this.currentEvent)
        .then((response) => {
          vm.$toasted.show(response.data.message, { duration: 3000, singleton: true, type: 'success' });
          this.scheduleEvents = this.scheduleEvents.filter(
            item => !item.isGeneratedRepeatEvent
              && item.originalEventID !== this.currentEvent.id,
          );
          this.generateRepeatEvents();
        })
        .catch((error) => {
          vm.$toasted.show(error.response.data.message, { duration: 3000, singleton: true, type: 'error' });
        });
    },
    deleteScheduleEvent() {
      const vm = this;

      this.closeEditEventModal();

      axios.delete(`${this.apiUrl}api/schedule/event/${this.currentEvent.id}`)
        .then((response) => {
          this.scheduleEvents = this.scheduleEvents.filter(
            item => item.id !== this.currentEvent.id
              && item.originalEventID !== this.currentEvent.id,
          );
          vm.$toasted.show(response.data.message, { duration: 3000, singleton: true, type: 'success' });
        })
        .catch((error) => {
          vm.$toasted.show(error.response.data.message, { duration: 3000, singleton: true, type: 'error' });
        });
    },
    setShowDate(d) {
      this.showDate = d;
    },
    openEditEventModal(calendarEvent) {
      if (calendarEvent.originalEvent.isGeneratedRepeatEvent) {
        const originalScheduleEvent = this.scheduleEvents.find(
          event => event.id === calendarEvent.originalEvent.originalEventID,
        );

        this.currentEvent = originalScheduleEvent;
      } else {
        this.currentEvent = calendarEvent.originalEvent;
      }

      /* eslint-disable no-param-reassign */
      this.colors.forEach((color) => {
        color.selected = false;
      });
      /* eslint-enable */

      if (this.currentEvent.classes) {
        const colorIndex = this.colors.findIndex(
          event => event.value === this.currentEvent.classes,
        );

        this.colors[colorIndex].selected = true;
      }

      this.editEventModalVisible = true;
    },
    closeEditEventModal() {
      this.editEventModalVisible = false;
      this.resetCurrentEventData();
    },
    closeCreateEventModal() {
      this.createEventModalVisible = false;
      this.resetNewEventData();
    },
    resetNewEventData() {
      this.newEventName = '';
      this.newEventPlaylistID = null;
      this.newEventStartDate = null;
      this.newEventStartDatePickerVisible = false;
      this.newEventEndDate = null;
      this.newEventEndDatePickerVisible = false;
      this.newEventStartTime = null;
      this.newEventEndTime = null;
      this.newEventRepeatInterval = null;
      this.newEventRepeatTime = null;
      this.newEventRepeatDay = null;
      this.newEventRepeatMonth = null;
      this.newEventRepeatColor = null;
    },
    resetCurrentEventData() {
      this.currentEventName = null;
    },
    setNewEventColor(colorIndex) {
      /* eslint-disable no-param-reassign */
      this.colors.forEach((color) => {
        color.selected = false;
      });
      /* eslint-enable */

      this.colors[colorIndex].selected = true;
      this.newEventColor = this.colors[colorIndex].value;
    },
    setCurrentEventColor(colorIndex) {
      const eventToModifyIndex = this.scheduleEvents.findIndex(
        event => event.id === this.currentEvent.id,
      );

      /* eslint-disable no-param-reassign */
      this.colors.forEach((color) => {
        color.selected = false;
      });
      /* eslint-enable */

      this.colors[colorIndex].selected = true;
      this.currentEvent.classes = this.colors[colorIndex].value;
      this.scheduleEvents[eventToModifyIndex].classes = this.colors[colorIndex].value;
    },
  },
};
</script>

<style>

</style>
